import api from './api';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  user: {
    id: string;
    name: string;
    email: string;
    role?: string;
    group_id?: number;
  };
  empresas?: Array<{
    id: number;
    nome: string;
    cnpj: string;
    solicitante_id: number;
    role?: string;
    group_id?: number;
  }>;
}

export interface TwoFactorResponse {
  requires_2fa: boolean;
  message?: string;
  access_token?: string;
  user?: {
    id: string;
    name: string;
    email: string;
    role?: string;
    group_id?: number;
  };
  empresas?: Array<{
    id: number;
    nome: string;
    cnpj: string;
    solicitante_id: number;
    role?: string;
    group_id?: number;
  }>;
}

export interface PasswordChangeResponse {
  requires_password_change: boolean;
  message?: string;
}

export interface ChangePasswordRequest {
  email: string;
  currentPassword: string;
  newPassword: string;
}

export const authService = {
  async login(data: LoginRequest): Promise<LoginResponse | TwoFactorResponse | PasswordChangeResponse> {
    const url = '/auth/client/login';
    const fullUrl = `${api.defaults.baseURL}${url}`;
    console.log('🔍 [authService.login] URL completa:', fullUrl);
    console.log('🔍 [authService.login] baseURL:', api.defaults.baseURL);
    console.log('🔍 [authService.login] Email:', data.email);

    try {
      const response = await api.post<LoginResponse | TwoFactorResponse | PasswordChangeResponse>(url, data);
      console.log('✅ [authService.login] Resposta recebida:', {
        requires_password_change: 'requires_password_change' in response.data,
        requires_2fa: 'requires_2fa' in response.data,
        has_access_token: 'access_token' in response.data,
      });
      return response.data;
    } catch (error: unknown) {
      const err = error as { message?: string; response?: { data?: unknown; status?: number }; config?: { url?: string; baseURL?: string } };
      console.error('❌ [authService.login] Erro na requisição:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        url: err.config?.url,
        baseURL: err.config?.baseURL,
      });
      throw error;
    }
  },

  async verifyTwoFactor(email: string, code: string): Promise<LoginResponse | PasswordChangeResponse> {
    const response = await api.post<LoginResponse | PasswordChangeResponse>('/auth/2fa/verify', {
      email,
      code,
    });
    return response.data;
  },

  async forgotPassword(email: string) {
    try {
      const response = await api.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error: unknown) {
      const err = error as { response?: { status?: number; data?: unknown } };
      // Se a API retornar erro mas com status 200, ainda é sucesso
      if (err.response?.status === 200) {
        return err.response.data;
      }
      throw error;
    }
  },

  async resetPassword(email: string, token: string, newPassword: string) {
    const response = await api.post('/auth/reset-password', {
      email,
      token,
      newPassword,
    });
    return response.data;
  },

  async changePassword(data: ChangePasswordRequest): Promise<TwoFactorResponse> {
    const response = await api.post<TwoFactorResponse>('/auth/change-password', data);
    return response.data;
  },

  async getEmpresas(): Promise<
    Array<{ id: number; nome: string; cnpj: string; solicitante_id: number; role?: string; group_id?: number }>
  > {
    const response = await api.get('/empresas');
    return response.data || [];
  },
};

